/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type {
  LiquidityProviderToken,
  LiquidityProviderTokenInterface,
} from "../LiquidityProviderToken";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lpTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum TransactionType",
        name: "transactionType",
        type: "uint8",
      },
    ],
    name: "LiquidityProviderTokenTransaction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lpTokenAmount",
        type: "uint256",
      },
    ],
    name: "burnLiquidityProviderToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTransactionFeesOwnerPercentage",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "stableTokenAddress",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lpTokenAmount",
        type: "uint256",
      },
    ],
    name: "liquidityAmountForTokenBurn",
    outputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "liquidityProviderByAddress",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "stableTokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ILiquidityProviderToken.LiquidityProvider",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "liquidityProviderById",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "stableTokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ILiquidityProviderToken.LiquidityProvider",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    name: "mintLiquidityProviderToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    name: "processTransactionFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "shareLandMarketAddress",
        type: "address",
      },
    ],
    name: "setExternalDependencies",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ownerWalletAddress",
        type: "address",
      },
    ],
    name: "setOwnerWalletAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    name: "tokenAmountForLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "0x608060405234801561001057600080fd5b50612ff6806100206000396000f3fe608060405234801561001057600080fd5b50600436106101805760003560e01c806301ffc9a71461018557806306fdde03146101ae578063077f224a146101c3578063095ea7b3146101d857806318160ddd146101eb5780631c86f3ad146101fc57806323b872dd1461021c578063248a9ca31461022f5780632f2ff15d14610242578063313ce5671461025557806336568abe14610264578063372500ab1461027757806337847ac71461027f5780633950935114610292578063442b1028146102a557806364ed65fc146102ac57806370a08231146102bf57806370a7c76e146102d25780637ee6a322146102e557806391d148541461030657806395d89b411461031957806397d86c4c1461032157806398500ff614610334578063a217fddf14610347578063a44a3e8f1461034f578063a457c2d714610362578063a65e96c514610375578063a9059cbb14610388578063d547741f1461039b578063dd62ed3e146103ae578063e58378bb146103c1578063f2fde38b146103d6575b600080fd5b610198610193366004611f28565b6103e9565b6040516101a59190611f5b565b60405180910390f35b6101b6610420565b6040516101a59190611fcb565b6101d66101d13660046120f7565b6104b2565b005b6101986101e636600461218b565b6105ec565b60ca545b6040516101a591906121ce565b61020f61020a3660046121dc565b610604565b6040516101a59190612238565b61019861022a366004612246565b61062e565b6101ef61023d36600461228c565b610654565b6101d66102503660046122ad565b610669565b60066040516101a591906122e9565b6101d66102723660046122ad565b61068a565b6101d66106c0565b6101d661028d36600461228c565b6108ea565b6101986102a036600461218b565b610a89565b60536101ef565b6101d66102ba3660046121dc565b610aab565b6101ef6102cd3660046121dc565b610b35565b6101d66102e03660046121dc565b610b50565b6102f86102f336600461228c565b610bb1565b6040516101a59291906122f7565b6101986103143660046122ad565b610ce5565b6101b6610d10565b6101ef61032f366004612312565b610d1f565b6101d661034236600461228c565b610e87565b6101ef600081565b61020f61035d36600461228c565b610fb9565b61019861037036600461218b565b611003565b6101d6610383366004612312565b61104b565b61019861039636600461218b565b611361565b6101d66103a93660046122ad565b61136f565b6101ef6103bc366004612334565b61138b565b6101ef600080516020612f8183398151915281565b6101d66103e43660046121dc565b6113b6565b60006001600160e01b03198216637965db0b60e01b148061041a57506301ffc9a760e01b6001600160e01b03198316145b92915050565b606060cb805461042f9061236c565b80601f016020809104026020016040519081016040528092919081815260200182805461045b9061236c565b80156104a85780601f1061047d576101008083540402835291602001916104a8565b820191906000526020600020905b81548152906001019060200180831161048b57829003601f168201915b5050505050905090565b600054610100900460ff16158080156104d25750600054600160ff909116105b806104ec5750303b1580156104ec575060005460ff166001145b6105115760405162461bcd60e51b8152600401610508906123dd565b60405180910390fd5b6000805460ff191660011790558015610534576000805461ff0019166101001790555b6001600160a01b03821661055a5760405162461bcd60e51b81526004016105089061242f565b61056484846113fe565b61056d3361142f565b60fb80546001600160a01b0384166001600160a01b031991821617909155600060ff5560fc80549091163317905580156105e6576000805461ff00191690556040517f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb3847402498906105dd9060019061245c565b60405180910390a15b50505050565b6000336105fa818585611467565b5060019392505050565b61060c611edc565b6001600160a01b038216600090815260fd602052604090205461041a90610fb9565b60003361063c85828561151b565b61064785858561155f565b60019150505b9392505050565b60009081526065602052604090206001015490565b61067282610654565b61067b81611580565b610685838361158a565b505050565b6001600160a01b03811633146106b25760405162461bcd60e51b8152600401610508906124b4565b6106bc8282611610565b5050565b60fa60009054906101000a90046001600160a01b03166001600160a01b0316633a283bd26040518163ffffffff1660e01b8152600401602060405180830381865afa158015610713573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061073791906124d7565b156107545760405162461bcd60e51b815260040161050890612523565b600061075f33610604565b905060006107748260400151620f4240611677565b905061078381620f4240612549565b826040018181516107949190612560565b9052506107a082611683565b60fa5460405163166a8f3b60e11b81526000916001600160a01b031690632cd51e76906107d39084903390600401612588565b602060405180830381865afa1580156107f0573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061081491906125ae565b9050808210156108365760405162461bcd60e51b815260040161050890612612565b60006108428284612560565b905080156108db5760fb5460405163a9059cbb60e01b81526001600160a01b039091169063a9059cbb9061087c9033908590600401612622565b6020604051808303816000875af115801561089b573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906108bf91906124d7565b6108db5760405162461bcd60e51b81526004016105089061265e565b81156105e6576105e6826116d9565b60fa60009054906101000a90046001600160a01b03166001600160a01b0316633a283bd26040518163ffffffff1660e01b8152600401602060405180830381865afa15801561093d573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061096191906124d7565b1561097e5760405162461bcd60e51b815260040161050890612523565b60008061098a83610bb1565b91509150610998338461195a565b60016109a333610b35565b10156109e85733600081815260fd602081815260408084208054855260fe83529084208481556001810180546001600160a01b03191690556002018490559383525290555b60fa5460405163072935f760e11b81526001600160a01b0390911690630e526bee90610a1c9085908590339060040161266e565b600060405180830381600087803b158015610a3657600080fd5b505af1158015610a4a573d6000803e3d6000fd5b50505050336001600160a01b0316600080516020612fa18339815191528383866006604051610a7c94939291906126da565b60405180910390a2505050565b6000336105fa818585610a9c838361138b565b610aa69190612718565b611467565b600080516020612f81833981519152610ac381611580565b6001600160a01b038216610ae95760405162461bcd60e51b815260040161050890612769565b60fa546001600160a01b031615610b125760405162461bcd60e51b8152600401610508906127aa565b5060fa80546001600160a01b0319166001600160a01b0392909216919091179055565b6001600160a01b0316600090815260c8602052604090205490565b600080516020612f81833981519152610b6881611580565b6001600160a01b038216610b8e5760405162461bcd60e51b8152600401610508906127f6565b5060fc80546001600160a01b0319166001600160a01b0392909216919091179055565b600080610bbd60ca5490565b60fa60009054906101000a90046001600160a01b03166001600160a01b03166369bb4dc26040518163ffffffff1660e01b8152600401602060405180830381865afa158015610c10573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c3491906125ae565b610c3e9085612549565b610c48919061281c565b9150610c5360ca5490565b60fa60009054906101000a90046001600160a01b03166001600160a01b03166315770f926040518163ffffffff1660e01b8152600401602060405180830381865afa158015610ca6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610cca91906125ae565b610cd49085612549565b610cde919061281c565b9050915091565b60009182526065602090815260408084206001600160a01b0393909316845291905290205460ff1690565b606060cc805461042f9061236c565b6000610d2a60ca5490565b15610e6e5760fa54604080516334dda6e160e11b815290516000926001600160a01b0316916369bb4dc29160048083019260209291908290030181865afa158015610d79573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d9d91906125ae565b84610da760ca5490565b610db19190612549565b610dbb919061281c565b9050600060fa60009054906101000a90046001600160a01b03166001600160a01b03166315770f926040518163ffffffff1660e01b8152600401602060405180830381865afa158015610e12573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e3691906125ae565b84610e4060ca5490565b610e4a9190612549565b610e54919061281c565b9050808210610e635780610e65565b815b9250505061041a565b610e80610e7b8484612549565b6119ff565b905061041a565b60fa546001600160a01b0316331480610f13575060fa5460408051630905de1760e41b8152905133926001600160a01b03169163905de1709160048083019260209291908290030181865afa158015610ee4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f08919061283b565b6001600160a01b0316145b80610f91575060fa5460408051633bb57add60e11b8152905133926001600160a01b03169163776af5ba9160048083019260209291908290030181865afa158015610f62573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f86919061283b565b6001600160a01b0316145b610fad5760405162461bcd60e51b81526004016105089061288a565b610fb6816116d9565b50565b610fc1611edc565b50600090815260fe602090815260409182902082516060810184528154815260018201546001600160a01b031692810192909252600201549181019190915290565b60003381611011828661138b565b9050838110156110335760405162461bcd60e51b8152600401610508906128da565b6110408286868403611467565b506001949350505050565b60fa60009054906101000a90046001600160a01b03166001600160a01b0316633a283bd26040518163ffffffff1660e01b8152600401602060405180830381865afa15801561109e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906110c291906124d7565b156110df5760405162461bcd60e51b815260040161050890612523565b60fa54604080516334dda6e160e11b815290516000926001600160a01b0316916369bb4dc29160048083019260209291908290030181865afa158015611129573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061114d91906125ae565b11156112a45760fa54604080516334dda6e160e11b815290516000926001600160a01b0316916369bb4dc29160048083019260209291908290030181865afa15801561119d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906111c191906125ae565b6111ce620f424085612549565b6111d9906064612549565b6111e3919061281c565b9050600060fa60009054906101000a90046001600160a01b03166001600160a01b03166315770f926040518163ffffffff1660e01b8152600401602060405180830381865afa15801561123a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061125e91906125ae565b61126b620f424085612549565b611276906064612549565b611280919061281c565b90508082146112a15760405162461bcd60e51b81526004016105089061291c565b50505b60006112b08383610d1f565b90506112bc3382611a6f565b6112cd6112c833611af3565b611683565b60fa546040516359e1d03560e11b81526001600160a01b039091169063b3c3a06a906113019086908690339060040161266e565b600060405180830381600087803b15801561131b57600080fd5b505af115801561132f573d6000803e3d6000fd5b50505050336001600160a01b0316600080516020612fa18339815191528484846005604051610a7c94939291906126da565b6000336105fa81858561155f565b61137882610654565b61138181611580565b6106858383611610565b6001600160a01b03918216600090815260c96020908152604080832093909416825291909152205490565b600080516020612f818339815191526113ce81611580565b6113e6600080516020612f8183398151915233611610565b6106bc600080516020612f818339815191528361158a565b600054610100900460ff166114255760405162461bcd60e51b815260040161050890612972565b6106bc8282611b23565b611437611b63565b61144f600080516020612f818339815191528261158a565b610fb6600080516020612f8183398151915280611b8c565b6001600160a01b03831661148d5760405162461bcd60e51b8152600401610508906129c1565b6001600160a01b0382166114b35760405162461bcd60e51b815260040161050890612a0e565b6001600160a01b03808416600081815260c9602090815260408083209487168084529490915290819020849055517f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b9259061150e9085906121ce565b60405180910390a3505050565b6000611527848461138b565b905060001981146105e657818110156115525760405162461bcd60e51b815260040161050890612a50565b6105e68484848403611467565b61156a838383611bdf565b600061157583611af3565b90506105e681611683565b610fb68133611cbd565b6115948282610ce5565b6106bc5760008281526065602090815260408083206001600160a01b03851684529091529020805460ff191660011790556115cc3390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b61161a8282610ce5565b156106bc5760008281526065602090815260408083206001600160a01b0385168085529252808320805460ff1916905551339285917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a45050565b600061064d828461281c565b8051600090815260fe602090815260408083208451808255838601516001830180546001600160a01b0319166001600160a01b0390921691821790559583015160029092019190915593835260fd909152902055565b60006116e460ca5490565b9050806000036117835760fb5460fc5460405163a9059cbb60e01b81526001600160a01b039283169263a9059cbb92611724929116908690600401612622565b6020604051808303816000875af1158015611743573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061176791906124d7565b6106bc5760405162461bcd60e51b815260040161050890612a9d565b60fa5460408051632cdefa3960e21b815281516000936001600160a01b03169263b37be8e492600480820193918290030181865afa1580156117c9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906117ed9190612aad565b915060009050611808611801605386612549565b6064611677565b905060006118168286612560565b9050818310611826575083905060005b60fb5460fc5460405163a9059cbb60e01b81526001600160a01b039283169263a9059cbb9261185c929116908690600401612622565b6020604051808303816000875af115801561187b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061189f91906124d7565b6118bb5760405162461bcd60e51b815260040161050890612b26565b80156119535760005b60ff548110156119515760006118de61035d836001612718565b80519091501561193e57600061190d6118fa8360200151610b35565b61190790620f4240612549565b88611677565b9050600061191b8286612549565b9050808360400181815161192f9190612718565b90525061193b83611683565b50505b508061194981612b36565b9150506118c4565b505b5050505050565b6001600160a01b0382166119805760405162461bcd60e51b815260040161050890612b8b565b6001600160a01b038216600090815260c86020526040902054818110156119b95760405162461bcd60e51b815260040161050890612bd8565b6001600160a01b038316600081815260c86020526040808220858503905560ca8054869003905551909190600080516020612f618339815191529061150e9086906121ce565b60006003821115611a605750806000611a1960028361281c565b611a24906001612718565b90505b81811015611a5a57905080600281611a3f818661281c565b611a499190612718565b611a53919061281c565b9050611a27565b50919050565b8115611a6a575060015b919050565b6001600160a01b038216611a955760405162461bcd60e51b815260040161050890612c1a565b8060ca6000828254611aa79190612718565b90915550506001600160a01b038216600081815260c8602052604080822080548501905551600080516020612f6183398151915290611ae79085906121ce565b60405180910390a35050565b611afb611edc565b6000611b0683610604565b90506001816000015110611b1a578061064d565b61064d83611d16565b600054610100900460ff16611b4a5760405162461bcd60e51b815260040161050890612972565b60cb611b568382612cd8565b5060cc6106858282612cd8565b600054610100900460ff16611b8a5760405162461bcd60e51b815260040161050890612972565b565b6000611b9783610654565b600084815260656020526040808220600101859055519192508391839186917fbd79b86ffe0ab8e8776151514217cd7cacd52c909f66475c3af44e129f0b00ff9190a4505050565b6001600160a01b038316611c055760405162461bcd60e51b815260040161050890612dd2565b6001600160a01b038216611c2b5760405162461bcd60e51b815260040161050890612e20565b6001600160a01b038316600090815260c8602052604090205481811015611c645760405162461bcd60e51b815260040161050890612e71565b6001600160a01b03808516600081815260c860205260408082208686039055928616808252908390208054860190559151600080516020612f6183398151915290611cb09086906121ce565b60405180910390a36105e6565b611cc78282610ce5565b6106bc57611cd481611d5f565b611cdf836020611d71565b604051602001611cf0929190612ea3565b60408051601f198184030181529082905262461bcd60e51b825261050891600401611fcb565b611d1e611edc565b600160ff6000828254611d319190612718565b90915550506040805160608101825260ff5481526001600160a01b0390931660208401526000908301525090565b606061041a6001600160a01b03831660145b60606000611d80836002612549565b611d8b906002612718565b6001600160401b03811115611da257611da2611fdc565b6040519080825280601f01601f191660200182016040528015611dcc576020820181803683370190505b509050600360fc1b81600081518110611de757611de7612ef3565b60200101906001600160f81b031916908160001a905350600f60fb1b81600181518110611e1657611e16612ef3565b60200101906001600160f81b031916908160001a9053506000611e3a846002612549565b611e45906001612718565b90505b6001811115611ebd576f181899199a1a9b1b9c1cb0b131b232b360811b85600f1660108110611e7957611e79612ef3565b1a60f81b828281518110611e8f57611e8f612ef3565b60200101906001600160f81b031916908160001a90535060049490941c93611eb681612f09565b9050611e48565b50831561064d5760405162461bcd60e51b815260040161050890612f50565b60405180606001604052806000815260200160006001600160a01b03168152602001600081525090565b6001600160e01b031981165b8114610fb657600080fd5b803561041a81611f06565b600060208284031215611f3d57611f3d600080fd5b6000611f498484611f1d565b949350505050565b8015155b82525050565b6020810161041a8284611f51565b60005b83811015611f84578181015183820152602001611f6c565b50506000910152565b601f01601f191690565b6000611fa1825190565b808452602084019350611fb8818560208601611f69565b611fc181611f8d565b9093019392505050565b6020808252810161064d8184611f97565b634e487b7160e01b600052604160045260246000fd5b611ffb82611f8d565b81016001600160401b038111828210171561201857612018611fdc565b6040525050565b600061202a60405190565b9050611a6a8282611ff2565b60006001600160401b0382111561204f5761204f611fdc565b61205882611f8d565b60200192915050565b82818337506000910152565b600061208061207b84612036565b61201f565b90508281526020810184848401111561209b5761209b600080fd5b6120a6848285612061565b509392505050565b600082601f8301126120c2576120c2600080fd5b8135611f4984826020860161206d565b60006001600160a01b03821661041a565b611f12816120d2565b803561041a816120e3565b60008060006060848603121561210f5761210f600080fd5b83356001600160401b0381111561212857612128600080fd5b612134868287016120ae565b93505060208401356001600160401b0381111561215357612153600080fd5b61215f868287016120ae565b9250506040612170868287016120ec565b9150509250925092565b80611f12565b803561041a8161217a565b600080604083850312156121a1576121a1600080fd5b60006121ad85856120ec565b92505060206121be85828601612180565b9150509250929050565b80611f55565b6020810161041a82846121c8565b6000602082840312156121f1576121f1600080fd5b6000611f4984846120ec565b611f55816120d2565b805161221283826121c8565b50602081015161222560208401826121fd565b50604081015161068560408401826121c8565b6060810161041a8284612206565b60008060006060848603121561225e5761225e600080fd5b600061226a86866120ec565b935050602061227b868287016120ec565b925050604061217086828701612180565b6000602082840312156122a1576122a1600080fd5b6000611f498484612180565b600080604083850312156122c3576122c3600080fd5b60006122cf8585612180565b92505060206121be858286016120ec565b60ff8116611f55565b6020810161041a82846122e0565b6040810161230582856121c8565b61064d60208301846121c8565b6000806040838503121561232857612328600080fd5b60006121ad8585612180565b6000806040838503121561234a5761234a600080fd5b60006122cf85856120ec565b634e487b7160e01b600052602260045260246000fd5b60028104600182168061238057607f821691505b602082108103611a5a57611a5a612356565b602e8152602081017f496e697469616c697a61626c653a20636f6e747261637420697320616c72656181526d191e481a5b9a5d1a585b1a5e995960921b602082015290505b60400190565b6020808252810161041a81612392565b60278152602081017f4c503a20537461626c6520746f6b656e2061646472657373206973206e6f74208152661919599a5b995960ca1b602082015290506123d7565b6020808252810161041a816123ed565b600061041a8261244d565b90565b60ff1690565b611f558161243f565b6020810161041a8284612453565b602f8152602081017f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636581526e103937b632b9903337b91039b2b63360891b602082015290506123d7565b6020808252810161041a8161246a565b801515611f12565b805161041a816124c4565b6000602082840312156124ec576124ec600080fd5b6000611f4984846124cc565b60148152602081017313140e8813585c9ad95d081a5cc81c185d5cd95960621b815290505b60200190565b6020808252810161041a816124f8565b634e487b7160e01b600052601160045260246000fd5b818102811582820484141761041a5761041a612533565b8181038181111561041a5761041a612533565b600061041a61244a8381565b611f5581612573565b60408101612596828561257f565b61064d60208301846121fd565b805161041a8161217a565b6000602082840312156125c3576125c3600080fd5b6000611f4984846125a3565b60288152602081017f4c503a205472616e73616374696f6e20666565732067726561746572207468618152671b88185b5bdd5b9d60c21b602082015290506123d7565b6020808252810161041a816125cf565b6040810161230582856121fd565b60198152602081017813140e8810db185a5b481d1c985b9cd9995c8819985a5b1959603a1b8152905061251d565b6020808252810161041a81612630565b6060810161267c82866121c8565b61268960208301856121c8565b611f4960408301846121fd565b634e487b7160e01b600052602160045260246000fd5b600c8110610fb657610fb6612696565b80611a6a816126ac565b600061041a826126bc565b611f55816126c6565b608081016126e882876121c8565b6126f560208301866121c8565b61270260408301856121c8565b61270f60608301846126d1565b95945050505050565b8082018082111561041a5761041a612533565b60238152602081017f4c503a204c616e64546f6b656e41646472657373206973206e6f7420646566698152621b995960ea1b602082015290506123d7565b6020808252810161041a8161272b565b601c8152602081017b13140e8811195c195b99195b98da595cc8185b1c9958591e481cd95d60221b8152905061251d565b6020808252810161041a81612779565b60218152602081017f4c503a206f776e657257616c6c65744164647265737320697320696e76616c698152601960fa1b602082015290506123d7565b6020808252810161041a816127ba565b634e487b7160e01b600052601260045260246000fd5b60008261282b5761282b612806565b500490565b805161041a816120e3565b60006020828403121561285057612850600080fd5b6000611f498484612830565b60198152602081017813140e8814d95b99195c881b9bdd081c9958dbd9db9a5e9959603a1b8152905061251d565b6020808252810161041a8161285c565b60258152602081017f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f77815264207a65726f60d81b602082015290506123d7565b6020808252810161041a8161289a565b601e8152602081017f4c503a20546f6b656e20726174696f20646f6573206e6f74206d6174636800008152905061251d565b6020808252810161041a816128ea565b602b8152602081017f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206981526a6e697469616c697a696e6760a81b602082015290506123d7565b6020808252810161041a8161292c565b60248152602081017f45524332303a20617070726f76652066726f6d20746865207a65726f206164648152637265737360e01b602082015290506123d7565b6020808252810161041a81612982565b60228152602081017f45524332303a20617070726f766520746f20746865207a65726f206164647265815261737360f01b602082015290506123d7565b6020808252810161041a816129d1565b601d8152602081017f45524332303a20696e73756666696369656e7420616c6c6f77616e63650000008152905061251d565b6020808252810161041a81612a1e565b60228152602081017f4c503a203020746f6b656e20737570706c79207472616e73666572206661696c815261195960f21b602082015290506123d7565b6020808252810161041a81612a60565b60008060408385031215612ac357612ac3600080fd5b6000612acf85856125a3565b92505060206121be858286016125a3565b602b8152602081017f4c503a2070657263656e7461676520746f6b656e20737570706c79207472616e81526a1cd9995c8819985a5b195960aa1b602082015290506123d7565b6020808252810161041a81612ae0565b600060018201612b4857612b48612533565b5060010190565b60218152602081017f45524332303a206275726e2066726f6d20746865207a65726f206164647265738152607360f81b602082015290506123d7565b6020808252810161041a81612b4f565b60228152602081017f45524332303a206275726e20616d6f756e7420657863656564732062616c616e815261636560f01b602082015290506123d7565b6020808252810161041a81612b9b565b601f8152602081017f45524332303a206d696e7420746f20746865207a65726f2061646472657373008152905061251d565b6020808252810161041a81612be8565b612c3383612573565b815460001960089490940293841b1916921b91909117905550565b6000610685818484612c2a565b818110156106bc57612c6e600082612c4e565b600101612c5b565b601f821115610685576000818152602090206020601f85010481016020851015612c9d5750805b6119536020601f860104830182612c5b565b6000196008929092029190911c191690565b612ccb8282612caf565b6002909202909117919050565b81516001600160401b03811115612cf157612cf1611fdc565b612cfb825461236c565b612d06828285612c76565b506020601f821160018114612d355760008315612d235750848201515b612d2d8482612cc1565b855550611953565b600084815260208120601f198516915b82811015612d655787850151825560209485019460019092019101612d45565b5084821015612d835783870151612d7f601f871682612caf565b8255505b50505050600202600101905550565b60258152602081017f45524332303a207472616e736665722066726f6d20746865207a65726f206164815264647265737360d81b602082015290506123d7565b6020808252810161041a81612d92565b60238152602081017f45524332303a207472616e7366657220746f20746865207a65726f206164647281526265737360e81b602082015290506123d7565b6020808252810161041a81612de2565b60268152602081017f45524332303a207472616e7366657220616d6f756e7420657863656564732062815265616c616e636560d01b602082015290506123d7565b6020808252810161041a81612e30565b6000612e8b825190565b612e99818560208601611f69565b9290920192915050565b76020b1b1b2b9b9a1b7b73a3937b61d1030b1b1b7bab73a1604d1b8152601701612ecd8184612e81565b7001034b99036b4b9b9b4b733903937b6329607d1b8152601101905061064d8183612e81565b634e487b7160e01b600052603260045260246000fd5b600081612f1857612f18612533565b506000190190565b60208082527f537472696e67733a20686578206c656e67746820696e73756666696369656e74910190815261251d565b6020808252810161041a81612f2056feddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef6270edb7c868f86fda4adedba75108201087268ea345934db8bad688e1feb91bbaa03b92d9c8ad054a91222b99ad9fc782907a36443b6579f9c4a685161897e8a264697066735822122028fa3d082e0d279ff4f18ea3170d56782fc37c7b170a0bb1d0e7c0e356421a7964736f6c63430008130033";

type LiquidityProviderTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: LiquidityProviderTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class LiquidityProviderToken__factory extends ContractFactory {
  constructor(...args: LiquidityProviderTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      LiquidityProviderToken & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null
  ): LiquidityProviderToken__factory {
    return super.connect(runner) as LiquidityProviderToken__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LiquidityProviderTokenInterface {
    return new Interface(_abi) as LiquidityProviderTokenInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): LiquidityProviderToken {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as LiquidityProviderToken;
  }
}
